<template>
    <div>
        <Head title="Blocker keywords"/>
        <h1 class="mb-8 text-3xl font-bold">Blocked chats</h1>
        <div class="flex items-center justify-between mb-6">
            <search-input v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
            </search-input>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto">
            <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                    <th class="pb-4 pt-6 px-6">Blocker keyword(s)</th>
                    <th class="pb-4 pt-6 px-6">Customer ID</th>
                    <th class="pb-4 pt-6 px-6">Girl</th>
                    <th class="pb-4 pt-6 px-6">Messages count</th>
                    <th class="pb-4 pt-6 px-6">Customer last activity</th>
                    <th class="pb-4 pt-6 px-6">BlockedAt</th>
                    <th class="pb-4 pt-6 px-6" colspan="2">&nbsp;</th>
                </tr>
                <tr v-for="row in chats" :key="row.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                    <td class="border-t">
                        <Link class="flex items-center px-4" :href="`/chats/${row.id}`" tabindex="-1">
                            {{ row.blocker_keywords?.join(', ') }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-4" :href="`/chats/${row.id}`" tabindex="-1">
                            {{ row.customer?.brand_name }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/chats/${row.id}`">
                            {{ row.girl?.firstname }} {{ row.girl?.lastname }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4" :href="`/chats/${row.id}`" tabindex="-1">
                            {{ row.messages_count }}
                        </Link>
                    </td>
                    <td class="border-t">
                        {{ row.customer_last_activity }}
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4" :href="`/chats/${row.id}`" tabindex="-1">
                            {{ row.blocked_at }}
                        </Link>
                    </td>
                    <td class="w-px border-t">
                        <loading-button
                            :loading="unlockLoading"
                            class="btn-indigo text-xs px-4 py-2 ml-auto"
                            type="button"
                            @click="unlockConversation(row.id)">Unlock
                        </loading-button>
                    </td>
                    <td class="w-px border-t">
                        <Link class="flex items-center px-4" :href="`/chats/${row.id}`" tabindex="-1">
                            <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400"/>
                        </Link>
                    </td>
                </tr>
                <tr v-if="chats.length === 0">
                    <td class="px-6 py-4 border-t" colspan="6">No chats found.</td>
                </tr>
            </table>
            <div class="bg-white p-4 flex items-center flex-wrap">
            <nav aria-label="Page navigation">
                <ul class="inline-flex">
                    <li v-for="link in paginator.links">
                        <Link :class="[link.active ? 'bg-indigo-600 text-white' : 'text-indigo-600 bg-white']" class="px-4 py-2 transition-colors duration-150 border border-indigo-600 focus:shadow-outline" :href="`${link.url}`" v-if="link.url">
                            {{link.label}}
                        </Link>
                        <Link class="px-4 py-2 transition-colors duration-150 border border-indigo-600 focus:shadow-outline" :href="`#`" v-else>
                            {{link.label}}
                        </Link>
                    </li>
                </ul>
            </nav>
        </div>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchInput from '@/Shared/SearchInput'
import SearchFilter from '@/Shared/SearchFilter'

export default {
    components: {
        Head,
        Icon,
        Link,
        SearchInput,
        SearchFilter
    },
    layout: Layout,
    props: {
        filters: Object,
        chats: Array,
        paginator: Object,
    },
    data() {
        return {
            form: {
                search: this.filters.search
            },
            languages: [
                {key: 'de', name: 'DE'},
                {key: 'en', name: 'EN'}
            ],
            unlockLoading: false
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                this.$inertia.get('/blocked-chats', pickBy(this.form), {preserveState: true})
            }, 150),
        },
    },
    methods: {
        reset() {
            this.form = mapValues(this.form, () => null)
        },
        unlockConversation(conversationId) {
            this.unlockLoading = true;
            axios.get(`/blocked-chats/unlock/${conversationId}`).then(result => {
                this.unlockLoading = false;
                if (result.data.success === true) {

                    const conversationIndex = this.chats?.findIndex(row => row.id == conversationId);

                    if (conversationIndex >= 0) {
                        this.chats?.splice(conversationIndex, 1);
                    }

                }
            }).catch(err => this.unlockLoading = false);
        }
    },
}
</script>
